import { fetchWithType } from './api';
import { getApiUrl } from './enviroment';

const base = `${getApiUrl()}/wp-json/felix`;

interface FelixOrder {
  firstName: string;
  lastName: string;
  street: string;
  zip: string;
  town: string;
  ssn: string;
  email: string;
  phone: string;
  url: string;
  date: string;
  notes?: string;
  wws?: string;
  referral_id?: string;
  id_source?: string;
  id_sub_source?: string;
  products: {
    id: string;
    name: string;
    quantity: number;
    rut: number;
    rot: number;
  }[];
  start_fees: {
    ID: number;
    price: number;
    rut: number;
    rot: number;
    green: number;
  }[];
  creditSafe: {
    firstName: string;
    lastName: string;
    street: string;
    zip: string;
    town: string;
  };
  felixStatus?: 'success' | 'error';
  customer?: string;
  seller_id?: string;
  refferal_id?: string;
}

const postPerson = async (felixOrder: FelixOrder) => {
  try {
    return await fetchWithType<
      | {
          response: {
            scriptResult: string;
            scriptError: string;
          };
          messages: [
            {
              code: string;
              message: string;
            },
          ];
        }
      | false
    >(`${base}/createperson`, {
      method: 'POST',
      body: JSON.stringify(felixOrder),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export { FelixOrder, postPerson };
